<template>
  <div id="payment-reminder-reports">
    <summary-reports />
    <client-table class='table'/>
  </div>
</template>

<script>
import { onMounted, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import SummaryReports from './Summary';
import ClientTable from './ClientTable';


const { useState, useActions } = createNamespacedHelpers('paymentReminder');

export default {
  name: 'PaymentReminderReports',
  components: {
    SummaryReports,
    ClientTable,
  },
  setup() {
    const { filters } = useState(['filters']);
    const { getSummaryInfo } = useActions(['getSummaryInfo']);

    const fetchData = async (f) => {
      const { terms, minApprovedAmount, maxApprovedAmount, branches, assetTypes, fromDate, toDate } = f;
      const params = {
        terms,
        minApprovedAmount: (minApprovedAmount || 0) * 1000000,
        maxApprovedAmount: (maxApprovedAmount || 0) * 1000000,
        branches,
        assetTypes,
        fromDate,
        toDate
      };
      getSummaryInfo(params);
    };

    watch(filters, (newFilters) => {
      fetchData(newFilters);
    });

    onMounted(() => {
      fetchData(filters);
    });
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#payment-reminder-reports {
  background-color: $babyPowder;
  border-radius: 4px;
  padding: 20px;

  .table {
    margin-top: 30px;
  }
}
</style>
